import React from "react";
import art_gif from "./../assets/images/art_gif.gif";

function About() {
  return (
    <React.Fragment>
      <>
        <div id="about" className="xl:px-0 py-24">
          <div className="mx-auto container">
            <h1 className="xl:text-4xl text-3xl text-center text-primary font-extrabold py-6 sm:w-4/6 w-5/6 mx-auto black-bruno">
              About Us
            </h1>
            <div className="mt-12 lg:mt-24 px-14">
              <div className="grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-16">
                <div>
                  <img
                    className="w-full rounded-xl"
                    src={art_gif}
                    alt="art gif"
                  />
                </div>
                <div>
                  <h2 className="text-3xl text-primary font-medium mb-2  black-bruno">
                    Who are Rebel Rhinos?
                  </h2>
                  <p>
                    Rebel Rhinos are an organisation who joined the Solana
                    Ecosystem with Web 3.0 in mind. With this lurking on the
                    horizon we thought it would be the ideal time to introduce
                    our project. We are focusing on creating a strong and
                    organic community who can help combat the main issues of
                    society, including the poaching of Rhinos. We are a strong
                    team of four who come from experienced development
                    backgrounds. We plan on providing large amounts of Utility
                    to our project, this will be disclosed overtime with further
                    details currently being within our Road Map. Our utility
                    will help spread awareness of the dangers Rhinos are
                    currently experiencing, with the rapid decrease in their
                    population, Extinction is becoming ever closer.
                  </p>
                  <h2 className="text-xl text-primary font-medium mt-8 black-bruno">
                    What are Rebel Rhinos?
                  </h2>
                  <p>
                    Rebel Rhinos are a collection of NFT's in a realistic 3D art
                    format. Each Rhino holds a large amount of utility, as shown
                    in our road map, more will be disclosed over time. Holders
                    will have the potential of receiving passive income from our
                    giving back to the community feature (More information to be
                    announced). Alongside this, generous donations to charity
                    will be made throughout the project that support our vision,
                    further information can be found within our road map
                    including our auctions where 100% of the proceeds go to
                    charity.
                  </p>
                  <h2 className="text-xl text-primary font-medium mt-8 black-bruno">
                    Why mint Rebel Rhinos?
                  </h2>
                  <p>
                    We plan on holding large amounts of virtual and IRL events
                    that not only our community can attend, but anyone that
                    shares our vision. This will provide further awareness to
                    our cause where we plan to have a community chosen charity
                    selected where all proceeds will be donated to through these
                    events. It will also provide a well bonded community as a
                    result of such events. You'll be able to join us on our
                    development journey when creating our Mobile Game. We will
                    be listening to our community throughout all aspects of the
                    game to provide a well adapted game suited to our community.
                    Stay posted for further details to be announced.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>

      <div className="bg-black flex   ">
        <div className="text-white xl:w-6/12 flex justify-center align-center"></div>
        <div className="text-white xl:w-6/12"></div>
      </div>
    </React.Fragment>
  );
}

export default About;
